import { render, staticRenderFns } from "./LoadableContainer.vue?vue&type=template&id=fd23a4ae&"
import script from "./LoadableContainer.vue?vue&type=script&lang=ts&"
export * from "./LoadableContainer.vue?vue&type=script&lang=ts&"
import style0 from "./LoadableContainer.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports